import React from "react";
import Avatar from "@mui/material/Avatar";
import PropTypes from "prop-types";
import ToolTip from "common/DS/Tooltip";

const LetterAvatar = ({ fullName, withTooltip, tooltipProps }) => {
    const [firstName = "", lastName = ""] = fullName?.split(" ") || [];
    const firstLetter = firstName.charAt(0).toUpperCase();
    const secondLetter = lastName.charAt(0).toUpperCase();

    const avatarEl = <Avatar className="ws-avatar">{`${firstLetter}${secondLetter}`}</Avatar>;
    return (
        <>
            {withTooltip && (
                <ToolTip title={fullName} {...tooltipProps}>
                    {avatarEl}
                </ToolTip>
            )}

            {!withTooltip && avatarEl}
        </>
    );
};

export default LetterAvatar;

LetterAvatar.propTypes = {
    fullName: PropTypes.node.isRequired,
    withTooltip: PropTypes.bool,
    tooltipProps: PropTypes.object,
};

LetterAvatar.defaultProps = {
    withTooltip: false,
    tooltipProps: {},
};
